




































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { FailureResponseData } from '../models/FailureResponseData'

@Component
export default class ErrorDialog extends Vue {
  @Prop({ default: false })
  public isShown!: boolean
  @Prop({ required: true })
  public failure!: FailureResponseData

  private privateIsShown: boolean = false

  @Watch('isShown')
  public onIsShownPropertyChanged(value: boolean, oldvalue: boolean) {
    this.privateIsShown = value
  }
  @Watch('privateIsShown')
  public onprivateIsShownPropertyChanged(value: boolean, oldvalue: boolean) {
    if (!value) {
      this.$emit('dialogClosed')
    }
  }
}
